import React, { useMemo } from 'react';
import {
  Grid,
  Typography,
  Alert,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material';
import { formatMatchDateTime } from '../../utils/matchTime';
import { getPastMatches } from '../../utils/tournamentPredictionWindows';
import {
  formatDealerPrediction,
  getOfficialMatchScoreText,
  pointsForPastGame,
} from '../../utils/tournamentScoring';

const PastGamesSection = ({ moduleConfig, campaignGoals, companyTimezone = 'UTC' }) => {
  const games = moduleConfig?.games || [];
  const goal = campaignGoals?.length ? campaignGoals[0] : null;
  const savedPredictions = goal?.extra?.games || [];

  const pastMatches = useMemo(
    () => getPastMatches(games, companyTimezone),
    [games, companyTimezone]
  );

  return (
    <Grid item xs={12} sx={{ pl: 0, mb: 4 }}>
      <Typography variant="h5" gutterBottom sx={{ fontWeight: 600, mb: 3 }}>
        PAST GAMES
      </Typography>

      {pastMatches.length === 0 ? (
        <Alert severity="info">No past matches yet</Alert>
      ) : (
        <TableContainer component={Paper} sx={{ backgroundColor: '#ffffff' }}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell sx={{ fontWeight: 600 }}>Match</TableCell>
                <TableCell sx={{ fontWeight: 600 }}>Date</TableCell>
                <TableCell align="center" sx={{ fontWeight: 600 }}>Score</TableCell>
                <TableCell align="center" sx={{ fontWeight: 600 }}>Your prediction</TableCell>
                <TableCell align="center" sx={{ fontWeight: 600 }}>Points</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {pastMatches.map(({ game, idx }) => {
                const predEntry = savedPredictions[idx];
                const officialScore = getOfficialMatchScoreText(game);
                const points = pointsForPastGame(game, predEntry);
                const formatted = formatMatchDateTime(game.date, game.time, companyTimezone);

                return (
                  <TableRow key={idx}>
                    <TableCell>
                      <Typography variant="body2" fontWeight="medium">
                        <span style={{ marginRight: '8px' }}>{game.team1_flag || '🇺🇳'}</span>
                        {game.team1} x {game.team2}
                        <span style={{ marginLeft: '8px' }}>{game.team2_flag || '🇺🇳'}</span>
                      </Typography>
                      <Typography variant="caption" color="text.secondary">
                        {game.stage} • {game.venue}
                      </Typography>
                    </TableCell>
                    <TableCell>
                      <Typography variant="body2">{formatted.date} {formatted.time}</Typography>
                    </TableCell>
                    <TableCell align="center">
                      <Typography variant="body2">{officialScore ?? '-'}</Typography>
                    </TableCell>
                    <TableCell align="center">
                      <Typography variant="body2">
                        {formatDealerPrediction(game, predEntry)}
                      </Typography>
                    </TableCell>
                    <TableCell align="center">
                      <Typography variant="body2">
                        {points == null ? '-' : points}
                      </Typography>
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </Grid>
  );
};

export default PastGamesSection;
